/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Vuex from "vuex";
//import createPersistedState from "vuex-persistedstate"

// Store functionality
import actions from "./actions";
import getters from "./getters";
import app from "./modules/app";
import login from "@/views/Login/_store";
import usuario from "@/views/Usuario/_store";
import cliente from "@/views/Cliente/_store";
import municipio from "@/views/Municipio/_store";
import colaborador from "@/views/Colaborador/_store";
import categoria from "@/views/Categoria/_store";
import pendencia from "@/views/Pendencia/_store";
import statusprocesso from "@/views/StatusProcesso/_store";
import tipoacionado from "@/views/TipoAcionado/_store";
import tipoprocesso from "@/views/TipoProcesso/_store";
import acionado from "@/views/Acionado/_store";
import processo from "@/views/Processo/_store";
import kit from "@/views/Kits/_store";
import enums from "./modules/enums";
import system from "./modules/system";
import atendimento from "@/views/Atendimento/_store";
import notificacao from "@/views/Notificacoes/_store";
import pagamentoProcesso from "@/views/Pagamentos/_store";
import orquestraFiles from "@/views/OrquestraFiles/_store";

import mutations from "./mutations";
import state from "./state";

Vue.use(Vuex);

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  mutations,
  actions,
  modules: {
    enums,
    login,
    usuario,
    app,
    cliente,
    municipio,
    colaborador,
    categoria,
    pendencia,
    statusprocesso,
    kit,
    tipoacionado,
    acionado,
    processo,
    tipoprocesso,
    atendimento,
    notificacao,
    pagamentoProcesso,
    orquestraFiles,
    system,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js